import { gql } from '@apollo/client';

const GET_READING_LOGS = gql`
  query getReadingLogs($where: ReadingLogsWhereInput!) {
    readingLogs(where: $where) {
      book {
        id
        title
      }
      bookCompleted
      dateCompleted
      dateStarted
      id
      pagesRead
    }
  }
`;

export default GET_READING_LOGS;
